export default class regExp {
    static email = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    static only_number = /^\d*$/;
    // static only_number_character = /^-?\d*\.?\d*$/;
    static phone_format = /^[+\d]?([\d-\s()]*)$/;
}